const PartnersBanner = (props: any) => {
    const banners = props.banners ? props.banners :  [
        {imgUrl: "/img/partner-logos/alcantara.png", imgWidth: "155px"},
        {imgUrl: "/img/partner-logos/studioart.png", imgWidth: "149px"},
        {imgUrl: "/img/partner-logos/misia.png", imgWidth: "108px"},
        {imgUrl: "/img/partner-logos/gandiablasco.png", imgWidth: "155px"},
    ];
    return (
        <div className='partners-banner'>
            <span className='p-exp p-l-exp'></span>
            {banners && banners.length > 0 ? (
                <ul style={props.columns ? {"gridTemplateColumns": props.columns} : {}}>
                    {banners.map((b: any, i: any) => {
                        return (
                            <li key={i}><img style={b.imgWidth ? {"width": b.imgWidth} : {}} src={b.imgUrl} alt="partner-banner" /></li>
                        )
                    })}
                </ul>
            ) : null}
            <span className='p-exp p-r-exp'></span>
        </div>
    )
}

export default PartnersBanner;